import { render, staticRenderFns } from "./ScoreCardV3.vue?vue&type=template&id=1b69041e&scoped=true&"
import script from "./ScoreCardV3.vue?vue&type=script&lang=js&"
export * from "./ScoreCardV3.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCardV3.vue?vue&type=style&index=0&id=1b69041e&prod&scoped=true&lang=css&"
import style1 from "./ScoreCardV3.vue?vue&type=style&index=1&id=1b69041e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b69041e",
  null
  
)

export default component.exports